import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="max-w-lg mx-auto px-4 py-24 text-center">
      <XCircle className="w-14 h-14 text-slate-400 mx-auto" />
      <h1 className="font-heading font-black text-2xl text-slate-950 mt-6">Payment cancelled</h1>
      <p className="text-slate-500 mt-2">No worries — you haven't been charged. Your selection is still saved, so you can complete your booking whenever you're ready.</p>
      <div className="mt-6 flex gap-3 justify-center">
        <Button onClick={() => navigate("/checkout")} className="rounded-full bg-coral hover:bg-coral-hover" data-testid="retry-payment">Complete booking</Button>
        <Button variant="outline" onClick={() => navigate("/")} className="rounded-full">Back to home</Button>
      </div>
    </div>
  );
}
